// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"mainContainer___3_fic"};